export default __webpack_public_path__ + "static/crescent@2x-713f87ffa0b7f604b3287a7e51999673.jpg";